import {createApi} from '@reduxjs/toolkit/query/react'

import {OtpRequest} from '../../../api-types/bovio/response/otp_request'
import {OtpVerify} from '../../../api-types/bovio/response/otp_verify'
import {fetchBaseQuery} from '../../../utils/network/fetchBaseQuery'
import {prepareBoVioHeaders} from '../../utils/prepareBovioHeaders'

import type {SharedRequestParams} from '../../types/Request'

export interface RequestOtpRequest extends SharedRequestParams {
  url: string
  bookingId: string
}

export interface VerifyOtpRequest extends SharedRequestParams {
  url: string
  bookingId: string
  /** The 4-digit code the user entered */
  code: string
  /** The OTP verification id returned by requestOtp */
  id: string
}

/**
 * API for the Booking Management OTP gate: requests a one-time code (auto-sent
 * to the booking email) and verifies the code entered by the user.
 */
export const otpApi = createApi({
  reducerPath: 'otpApi',
  baseQuery: fetchBaseQuery({
    baseUrl: ''
  }),
  endpoints: builder => ({
    requestOtp: builder.mutation<OtpRequest, RequestOtpRequest>({
      query: ({url, bookingId, ...rest}) => ({
        url: `${url}bookings/${bookingId}/otp`,
        method: 'POST',
        headers: prepareBoVioHeaders(rest)
      })
    }),
    verifyOtp: builder.mutation<OtpVerify, VerifyOtpRequest>({
      query: ({url, bookingId, code, id, ...rest}) => ({
        url: `${url}bookings/${bookingId}/otp/verify`,
        method: 'POST',
        data: {code, id},
        headers: prepareBoVioHeaders(rest)
      })
    })
  })
})

export const REQUEST_OTP_CACHE_KEY = 'request-otp'
export const VERIFY_OTP_CACHE_KEY = 'verify-otp'

export const {useRequestOtpMutation, useVerifyOtpMutation} = otpApi
